export const MESSAGE_TYPE_RECEIVED = "received";
export const MESSAGE_TYPE_SENT = "sent";
export const MESSAGE_TYPE_NEW = "MESSAGE_TYPE_NEW";
export const MESSAGE_TYPE_EDIT = "MESSAGE_TYPE_EDIT";
export const FORM_TYPE_CREATE = "FORM_TYPE_CREATE";
export const FORM_TYPE_NONE = "FORM_TYPE_NONE";
